/**
 * The super-admin wide-event screens' search enums: the router's inputs and the routes' eager search schemas. A leaf
 * of plain constants, so a route's eager half pulls in nothing else (docs/notes/app/chunking-policy.md).
 */

/** The log explorer's presets; a zoom replaces them with explicit bounds, capped at the longest. */
export const LOG_RANGES = ['15m', '1h', '6h', '24h', '7d', '30d'] as const
export type LogRange = (typeof LOG_RANGES)[number]
export const DEFAULT_LOG_RANGE: LogRange = '24h'

/** The errors screen's occurrence window: the sparkline, counts and users per issue. */
export const ERROR_RANGES = ['24h', '7d', '30d'] as const
export type ErrorRange = (typeof ERROR_RANGES)[number]
export const ERROR_SORTS = ['recent', 'events', 'users', 'new'] as const
export type ErrorSort = (typeof ERROR_SORTS)[number]

/** The traces explorer's ranges; a session or a single trace is windowed around its own moment instead. */
export const TRACE_SINCE = ['1h', '24h', '7d'] as const
export type TraceSince = (typeof TRACE_SINCE)[number]
